export class HeaderMobile {
	element = document.querySelector('.header-mobile');
	activeClass = 'header-mobile--active';

	constructor() {
		this.init();
	}


	toggleMenu = () => {
		if (this.element.classList.contains(this.activeClass)) this.closeMenu();
		else this.openMenu();
	};

	openMenu = () => {
		window.app?.disableScroll();
		this.element.classList.add(this.activeClass);
	};

	closeMenu = () => {
		window.app?.enableScroll();
		this.element.classList.remove(this.activeClass);
	};

	searchOpen = () => window.dispatchEvent(new CustomEvent('mobileSearchOpen'));

	clickHandler = ({ target }) => {
		if (target.closest('.header-mobile__opener')) this.toggleMenu();
		if (target.closest('.header-menu__close')) this.closeMenu();
		if (target.closest('.header-mobile__item--search')) this.searchOpen();
	};

	init = () => {
		if (!this.element) return;
		this.element.addEventListener('click', this.clickHandler);
	};
}
